import React, { useState } from "react";

import { Accordion as ChakraUiAccordion } from "@chakra-ui/react";
import { SelectValueChangeDetails } from "@chakra-ui/react";
import { ReactComponent as ChevronDownIcon } from "assets/icons/chevron-down-black.svg";
import { START_INDEX } from "utils/constants";
import { Maybe } from "utils/general/maybe";

import { accordionItemTriggerCss, defaultAccordionItemBodyCss } from "./styles";
import { IAccordionProps } from "./types";

const ACCORDION_ITEMS_INDEX_OFFSET = 1;
export const Accordion = (props: IAccordionProps) => {
  const { accordionItems, accordionRootCss, accordionItemBodyCss } = props;
  const [expandedItem, setExpandedItem] = useState("");

  const handleAccordionItemExpand = (details: SelectValueChangeDetails) => {
    const {
      value: [currentExpandedItem],
    } = details;
    setExpandedItem(currentExpandedItem);
  };

  return (
    <ChakraUiAccordion.Root
      onValueChange={handleAccordionItemExpand}
      collapsible
      css={accordionRootCss}
    >
      {accordionItems.map(({ value, header, body }, index) => (
        <ChakraUiAccordion.Item
          key={index}
          value={value}
        >
          <ChakraUiAccordion.ItemTrigger
            css={{
              ...accordionItemTriggerCss,
              borderBottom:
                expandedItem === value ||
                index === accordionItems.length - ACCORDION_ITEMS_INDEX_OFFSET
                  ? "none"
                  : "1px solid #EAECF0",
              paddingTop: index === START_INDEX ? "0" : "16px",
            }}
          >
            <div className="h-6 flex items-center justify-between w-full">
              <div>{header}</div>
              <div>
                <ChevronDownIcon
                  className={`${expandedItem === value ? "rotate-180" : ""}`}
                />
              </div>
            </div>
          </ChakraUiAccordion.ItemTrigger>
          <ChakraUiAccordion.ItemContent
            css={{
              borderBottom:
                index ===
                  accordionItems.length - ACCORDION_ITEMS_INDEX_OFFSET ||
                expandedItem !== value
                  ? "none"
                  : "1px solid #EAECF0",
            }}
          >
            <ChakraUiAccordion.ItemBody
              css={{ ...defaultAccordionItemBodyCss, ...accordionItemBodyCss }}
            >
              <Maybe condition={expandedItem === value}>{body}</Maybe>
            </ChakraUiAccordion.ItemBody>
          </ChakraUiAccordion.ItemContent>
        </ChakraUiAccordion.Item>
      ))}
    </ChakraUiAccordion.Root>
  );
};
